import { HolidayTable } from 'components/table/holiday/HolidayTable'

export const Holidays = () => {
    return (
        <>
            <HolidayTable></HolidayTable>
        </>
    )
}